/**
 * 积分图标工具函数
 * 根据积分名称返回对应的图标
 */

// 积分名称对应的图标映射
const POINTS_ICON_MAP: Record<string, string> = {
  '星星': 'ri-star-fill',
  '金币': 'ri-coin-fill',
  '友爱分': 'ri-heart-fill',
  '彩虹豆': 'ri-rainbow-fill',
  '勇气值': 'ri-flashlight-fill',
  '钻石': 'ri-diamond-2-fill',
  '阳光': 'ri-sun-fill',
  '月亮': 'ri-moon-fill',
  '花朵': 'ri-flower-fill',
  '皇冠': 'ri-vip-crown-fill',
  '火箭': 'ri-rocket-fill',
  '音符': 'ri-music-fill',
  '书本': 'ri-book-fill',
  '奖杯': 'ri-trophy-fill',
  '奖章': 'ri-medal-fill',
};

/**
 * 根据积分名称获取对应的图标类名
 * @param pointName 积分名称（如"星星"、"金币"等）
 * @returns 图标类名（如"ri-star-fill"）
 */
export function getPointsIcon(pointName: string | undefined | null): string {
  if (!pointName) return 'ri-star-fill';

  // 精确匹配
  if (POINTS_ICON_MAP[pointName]) return POINTS_ICON_MAP[pointName];

  // 模糊匹配
  for (const [key, icon] of Object.entries(POINTS_ICON_MAP)) {
    if (pointName.includes(key)) return icon;
  }

  // 默认星星图标
  return 'ri-star-fill';
}

/**
 * 获取积分名称，默认为"星星"
 */
export function getPointsName(pointName: string | undefined | null): string {
  return pointName || '星星';
}
